import(/* webpackMode: "eager" */ "/Users/martina/Desktop/stg-temp-0106v2/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/Users/martina/Desktop/stg-temp-0106v2/components/sentry-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/Users/martina/Desktop/stg-temp-0106v2/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/Users/martina/Desktop/stg-temp-0106v2/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/Users/martina/Desktop/stg-temp-0106v2/components/ui/tooltip.tsx");
